import React from "react";
import PropTypes from "prop-types";
import ftmlogo from "../assets/images/fresh-thyme-market-logo.png";
import {useLocation} from "react-router-dom";
import NotFound from "../components/notFound/NotFound";

const AccountDeleted = ({redirectUri}) => {
    const location = useLocation();
    const action = location?.state?.action;

    const isDeleted = action === "deleted-account";
    const isDeleteFailed = action === "deletion-failed";

    if (!isDeleted && !isDeleteFailed) {
        return <NotFound/>;
    }

    return (
        <main className="delete-container">
            <section
                className="delete-card"
                aria-labelledby="delete-title"
            >
                <a
                    href={redirectUri}
                    className="logo-link"
                    aria-label="Go to home page"
                >
                    <img
                        src={ftmlogo}
                        alt="Fresh Thyme Market logo"
                        className="logo-image"
                    />
                </a>

                <div className="delete-content">
                    <h1 id="delete-title" className="delete-title">
                        {isDeleted ? "Account Deleted" : "Unable to Delete Account"}
                    </h1>

                    {isDeleted ? (
                        <>
                            <p className="delete-text">
                                Your account has been permanently deleted.
                            </p>

                            <p className="delete-text">
                                We’re sorry to see you go.
                            </p>

                            <p className="delete-text">
                                You’re always welcome to join Fresh Thyme again!
                            </p>

                            <a
                                href={redirectUri}
                                className="ok-button"
                            >
                                OK
                            </a>
                        </>
                    ) : (
                        <>
                            <p className="delete-text">
                                We were unable to delete your account at this time.
                            </p>

                            <p className="delete-text">
                                Please try again later or manage your account settings.
                            </p>

                            <div className="button-group">
                                {isDeleted ? (
                                    <a
                                        href={redirectUri}
                                        className="ok-button"
                                    >
                                        Go to Home Page
                                    </a>
                                ) : (
                                    <a
                                        href={`${window.location.origin}/account-settings`}
                                        className="ok-button"
                                    >
                                        Account Settings Page
                                    </a>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </section>
        </main>
    );
};

AccountDeleted.propTypes = {
    redirectUri: PropTypes.string
};

AccountDeleted.defaultProps = {
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "/"
};

export default AccountDeleted;